import { useLanguage } from '@/i18n/LanguageContext';
import { useSiteSettings } from '@/hooks/useSiteSettings';

const MaintenancePage = () => {
  const { language } = useLanguage();
  const { settings } = useSiteSettings();

  const message = language === 'de'
    ? (settings.maintenance_message_de || 'Wir aktualisieren derzeit unsere Website.')
    : (settings.maintenance_message_en || 'We are currently updating our website.');

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-background px-6">
      <div className="max-w-lg text-center">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-6">
          Szoradi Instruments
        </h1>
        <div className="w-16 h-px bg-gold mx-auto mb-8" aria-hidden="true" />
        <p className="text-lg text-muted-foreground leading-relaxed">
          {message}
        </p>
      </div>
    </main>
  );
};

export default MaintenancePage;
